import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-create-supplier',
    templateUrl: './create-supplier.component.html',
    styleUrls: ['./create-supplier.component.css', '../../app.component.css']
})

export class CreateSupplierComponent implements OnInit, OnDestroy {

    supplierForm: FormGroup;
    supplier: any;

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    sub: Subscription;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private customerSupplierService: CustomerSupplierService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();
    }

    ngOnInit() {
        this.supplierForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            subsidiary: ['', Validators.required]
        });
    }
    ngOnDestroy(){
        this.sub.unsubscribe();
    }

    onSubmitSupplier() {
        this.supplier = this.saveSupplier();

        this.customerSupplierService.postCustomerSupplier(this.supplier);
    }

    saveSupplier() {
        const currentDate = new Date();

        const supplierJson = {
            active: 1,
            clientSince: '',
            createdAt: currentDate,
            description: this.supplierForm.get('description').value,
            email: this.supplierForm.get('email').value,
            name: this.supplierForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.supplierForm.get('subsidiary').value],
            typeId: '3',
            updatedAt: currentDate
        };

        return supplierJson;
    }

    loadSubsidiaries() {
        this.sub = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

			if(tempSubsidiaries.length == 1) this.supplierForm.get('subsidiary').patchValue(tempSubsidiaries[0].name);

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

}
